<div id="rrhh-team-info-form-container">
  <h2 class="heading-02-semi-bold grey-900">Información básica</h2>
  <div class="row">
    <div class="input-box">
      <p class="label subheading-01-semi-bold grey-800">Nombre</p>
      <div class="input-container">
        <qr-input
          [config]="inputName"
          (valueChange)="changeTeamName($event)"
          [value]="teamName"
          *ngIf="readyData"
        ></qr-input>
        <div class="skeleton-loader-input-name" *ngIf="!readyData">
          <qr-skeleton-loader></qr-skeleton-loader>
        </div>
      </div>
    </div>
    <!-- En Ecuador no existen los team leader -->
    <div class="input-box" *ngIf="NODE != NODE_EC">
      <p class="label subheading-01-semi-bold grey-800">Team Leader</p>
      <div class="input-container">
        <qr-input-autocomplete
          [config]="inputAutocompleteTeamLeader"
          [value]="nameTeamLeaderSelected"
          [isDisabled]="!readyData && !isEdit"
          (selectedChange)="changeTeamLeaderName($event)"
          *ngIf="readyData"
        ></qr-input-autocomplete>
        <div class="skeleton-loader-input-name" *ngIf="!readyData">
          <qr-skeleton-loader></qr-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="input-box photo-section">
      <div class="label">
        <p class="subheading-01-semi-bold grey-800">Foto del Team</p>
      </div>
      <div class="preview-photo">
        <div id="photo-container">
          <qr-skeleton-loader *ngIf="!readyData"></qr-skeleton-loader>
          <div id="icon-container" *ngIf="readyData">
            <qr-icon
              name="agent"
              color="primary-500"
              *ngIf="!uploadedFileStatus"
            ></qr-icon>
            <img
              id="agent-photo"
              [src]="previewImageUrl"
              alt=""
              *ngIf="uploadedFileStatus"
            />
          </div>
        </div>
      </div>
      <div class="add-photo">
        <div id="add-photo-button" *ngIf="!uploadedFileStatus">
          <input
            hidden
            type="file"
            multiple="false"
            #uploader
            (change)="addFile($event)"
            accept="image/png, image/jpg, image/jpeg"
          />
          <qr-button
            [config]="buttonAddPhoto"
            (click)="uploader.click()"
          ></qr-button>
        </div>
        <div class="uploaded-file" *ngIf="uploadedFileStatus">
          <qr-icon name="picture" color="grey-500"></qr-icon>
          <span class="caption-01-regular" [matTooltip]="fileName">{{
            fileName ? fileName : "Imagen"
          }}</span>
          <qr-button
            [config]="buttonDeleteFile"
            [isDisabled]="true"
            (click)="deleteFile()"
            matTooltip="Eliminar archivo"
          ></qr-button>
        </div>
        <p class="paragraph-02-regular">
          Las dimensiones máximas permitidas <br />
          para la imagen son 600x600 píxeles
        </p>
        <p class="paragraph-02-regular">
          El tamaño máximo permitido para la imagen es <br />
          de 2 MB. Archivos soportados JPG, JPEG, PNG
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Dialogo para importar Team -->
<qr-dialog
  [config]="dialogImportTeam"
  (dialogChange)="dialogImportTeamChange($event)"
></qr-dialog>
